/**
 * APH display-only FX converter.
 * - Shop still bills in GBP (T&Cs).
 * - Not Shopify Markets / no apps.
 * - Live rates vs GBP (Frankfurter/ECB + fallback). Mid-market style, close to Google.
 * - Converts any [data-gbp] element; auto-tags Shopify money if shop is GBP.
 */
(function () {
  'use strict';

  window.APH = window.APH || {};
  window.APH.currency = window.APH.currency || { code: 'GBP', symbol: '£', rate: 1 };

  var STORAGE_KEY = 'aph_currency_code';
  var RATES_KEY = 'aph_fx_rates_gbp';
  var RATES_TTL_MS = 60 * 60 * 1000; // 1 hour cache

  function formatPrice(gbp) {
    var cur = window.APH.currency || { symbol: '£', rate: 1, code: 'GBP' };
    var n = Number(gbp);
    if (isNaN(n)) n = 0;
    var converted = n * (cur.rate || 1);
    var symbol = cur.symbol || '£';
    // Google-style: 2 dp for most, no space after symbol for £ $ €
    return symbol + converted.toFixed(2);
  }
  window.APH.formatPrice = formatPrice;

  /* Integer pence. Never float 44.99 * 2 (that is 89.97). */
  function toPence(gbp) {
    return Math.round(Number(gbp) * 100) || 0;
  }
  function fromPence(pence) {
    return (Math.round(Number(pence)) || 0) / 100;
  }
  function lineFromUnitQty(unitGbp, qty) {
    var q = parseInt(qty, 10) || 0;
    if (q < 0) q = 0;
    return fromPence(toPence(unitGbp) * q);
  }
  window.APH.toPence = toPence;
  window.APH.fromPence = fromPence;
  window.APH.lineFromUnitQty = lineFromUnitQty;

  function setAtcLabel(btn, totalGbp) {
    if (!btn) return;
    var total = fromPence(toPence(totalGbp));
    if (isNaN(total) || total < 0) total = 0;
    btn.querySelectorAll('.btn-roll-inner > span').forEach(function (span) {
      var price = span.querySelector('[data-atc-price]');
      if (!price) {
        span.textContent = '';
        span.appendChild(document.createTextNode('Add To Cart - '));
        price = document.createElement('span');
        price.setAttribute('data-atc-price', '');
        price.className = 'cur-price';
        span.appendChild(price);
      } else if (span.firstChild && span.firstChild.nodeType === 3) {
        span.firstChild.textContent = 'Add To Cart - ';
      }
      price.setAttribute('data-gbp', total.toFixed(2));
      price.textContent = formatPrice(total);
    });
  }
  window.APH.setAtcLabel = setAtcLabel;

  function parseMoneyText(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^\d.,-]/g, '').replace(/,/g, '');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  /** Tag Shopify money elements once with data-gbp (shop currency must be GBP). */
  function tagMoneyElements(root) {
    var scope = root || document;
    var selectors = [
      '.price-item',
      '.price__regular .price-item',
      '.price__sale .price-item',
      '[data-aph-price] .price',
      '[data-aph-price] .price-compare',
      '.price-row .price',
      '.price-row .price-compare',
      '.cart-item__price',
      '.cart-item__line-price',
      '.cart-item__old-price',
      '#main-cart-items .price',
      '#main-cart-items .price--end',
      '#main-cart-footer .totals__total-value',
      '.aph-cart-totals-row span',
      '.aph-tier-chip b',
      '[data-cart-shipping-text] b',
      '.totals__subtotal-value',
      '.tax-note',
      '[data-cart-subtotal]',
      '.mobile-nav-card-price',
    ];
    selectors.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (el) {
        if (el.hasAttribute('data-gbp')) return;
        if (el.querySelector('[data-gbp]')) return;
        if (el.closest('[data-currency-picker]')) return;
        var n = parseMoneyText(el.textContent);
        if (n == null) return;
        // Only treat as GBP base if current FX is GBP or not yet converted
        el.setAttribute('data-gbp', n.toFixed(2));
        el.classList.add('cur-price');
      });
    });
  }

  function applyCurrencyToDom() {
    tagMoneyElements(document);
    document.querySelectorAll('[data-gbp]').forEach(function (el) {
      var gbp = parseFloat(el.getAttribute('data-gbp'));
      if (isNaN(gbp)) return;
      /* Odometer buy-box: show LINE total when bulk tiers set data-line-gbp.
         Never snap mid-animation (bulk reel). */
      if (el.closest('.price-compare, .upsell-price-was')) {
        el.removeAttribute('data-odometer');
        el.classList.remove('price-odometer');
        el.textContent = formatPrice(gbp);
      } else if (el.getAttribute('data-odometer') === '1' && typeof window.APH.animatePrice === 'function') {
        if (el._odAnimating) return;
        var line = parseFloat(el.getAttribute('data-line-gbp'));
        var displayGbp = !isNaN(line) ? line : gbp;
        el._odValue = displayGbp;
        window.APH.animatePrice(el, displayGbp, { duration: 0 });
      } else if (el.hasAttribute('data-cart-subtotal') || el.classList.contains('aph-cart-subtotal-value')) {
        /* Cart JS owns this node - only re-format locked GBP major units */
        if (el.dataset.locked === '1' && !isNaN(gbp)) {
          el.textContent = formatPrice(gbp);
        }
      } else {
        el.textContent = formatPrice(gbp);
      }
    });
    refreshAtcLabels();
    if (typeof window.APH.updateBuyBoxTotal === 'function') {
      try {
        window.APH.updateBuyBoxTotal();
      } catch (e) {}
    }
    refreshAtcLabels();
    document.dispatchEvent(
      new CustomEvent('aph:currency', { detail: window.APH.currency })
    );
  }

  /* ATC label. Recharge on = product line + one Recharge (pence, no 54.99+39.99 float). */
  function cycleUpsellRowFor(buyBox, section) {
    var host = (buyBox && (buyBox.closest('[data-aph-buy-box], #buy-box, [data-aph-atc-wrap]'))) || buyBox;
    var n = host;
    while (n && n !== section) {
      var prev = n.previousElementSibling;
      while (prev) {
        if (prev.getAttribute && prev.getAttribute('data-pdp-cycle-upsell') != null) return prev;
        var inner = prev.querySelector && prev.querySelector('[data-pdp-cycle-upsell]');
        if (inner) return inner;
        prev = prev.previousElementSibling;
      }
      n = n.parentElement;
    }
    return (section && section.querySelector('[data-pdp-cycle-upsell]')) || null;
  }

  function refreshAtcLabels() {
    document.querySelectorAll('[data-aph-atc]').forEach(function (btn) {
      var buyBox = btn.closest('.featured-cta-row') || btn.closest('form') || btn.parentElement;
      if (!buyBox) return;
      var section = (buyBox.closest && buyBox.closest('.shopify-section')) || document;
      var qtyEl = buyBox.querySelector && buyBox.querySelector('.qty-value, [data-qty-value]');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      if (qty < 1) qty = 1;
      var priceEl =
        section.querySelector('[data-aph-price] .cur-price[data-gbp]') ||
        section.querySelector('[data-aph-price] [data-gbp]') ||
        section.querySelector('.featured-copy .price-row .price .cur-price[data-gbp]') ||
        section.querySelector('.price-row .price .cur-price[data-gbp]');
      var unit = 0;
      var lineRaw = '';
      if (priceEl) {
        unit = parseFloat(priceEl.getAttribute('data-unit-gbp'));
        if (isNaN(unit) || unit < 0) {
          unit = parseFloat(priceEl.getAttribute('data-base-gbp'));
        }
        if (isNaN(unit) || unit < 0) unit = parseFloat(priceEl.getAttribute('data-gbp')) || 0;
        lineRaw = priceEl.getAttribute('data-line-gbp');
      } else {
        var own = btn.querySelector('[data-atc-price][data-gbp]');
        if (own) {
          unit = parseFloat(own.getAttribute('data-unit-gbp'));
          if (isNaN(unit) || unit < 0) {
            unit = parseFloat(own.getAttribute('data-base-gbp'));
          }
          if (isNaN(unit) || unit < 0) unit = parseFloat(own.getAttribute('data-gbp')) || 0;
        }
      }
      var productPence =
        lineRaw != null && lineRaw !== ''
          ? toPence(lineRaw)
          : toPence(unit) * qty;
      var upsellRow = cycleUpsellRowFor(buyBox, section);
      var upsellBox = upsellRow && upsellRow.querySelector('[data-upsell-toggle], input[type="checkbox"]');
      var extra = 0;
      if (upsellBox && upsellBox.checked && !upsellBox.disabled) {
        extra = toPence(upsellRow.getAttribute('data-upsell-price-gbp'));
      }
      setAtcLabel(btn, fromPence(productPence + extra));
    });
  }
  window.APH.refreshAtcLabels = refreshAtcLabels;
  window.APH.applyCurrency = applyCurrencyToDom;

  if (!window.__aphCycleAtcSumBound) {
    window.__aphCycleAtcSumBound = true;
    function kickAtcSum() {
      refreshAtcLabels();
    }
    document.addEventListener(
      'change',
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('[data-pdp-cycle-upsell], [data-upsell-toggle]')) return;
        kickAtcSum();
      },
      true
    );
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('[data-pdp-cycle-upsell]')) return;
        setTimeout(kickAtcSum, 0);
      },
      true
    );
  }

  function loadCachedRates() {
    try {
      var raw = localStorage.getItem(RATES_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.ts || !data.rates) return null;
      if (Date.now() - data.ts > RATES_TTL_MS) return null;
      return data.rates;
    } catch (e) {
      return null;
    }
  }

  function saveRates(rates) {
    try {
      localStorage.setItem(RATES_KEY, JSON.stringify({ ts: Date.now(), rates: rates }));
    } catch (e) {}
  }

  /** Live mid-market rates from GBP. jsDelivr first - never frankfurter.app (CORS). */
  function fetchRates() {
    var cached = loadCachedRates();
    if (cached) return Promise.resolve(cached);

    var endpoints = [
      'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/gbp.min.json',
      'https://latest.currency-api.pages.dev/v1/currencies/gbp.min.json',
    ];

    function normalize(json, url) {
      var rates = { GBP: 1 };
      if (json && json.rates) {
        Object.keys(json.rates).forEach(function (k) {
          rates[k.toUpperCase()] = Number(json.rates[k]);
        });
        return rates;
      }
      // fawazahmed0 shape: { gbp: { usd: 1.27, ... } }
      if (json && json.gbp) {
        Object.keys(json.gbp).forEach(function (k) {
          rates[k.toUpperCase()] = Number(json.gbp[k]);
        });
        return rates;
      }
      return null;
    }

    return endpoints
      .reduce(function (chain, url) {
        return chain.catch(function () {
          return fetch(url, { credentials: 'omit', mode: 'cors' }).then(function (r) {
            if (!r.ok) throw new Error('fx ' + r.status);
            return r.json();
          }).then(function (json) {
            var rates = normalize(json, url);
            if (!rates) throw new Error('bad fx payload');
            rates.GBP = 1;
            saveRates(rates);
            return rates;
          });
        });
      }, Promise.reject())
      .catch(function () {
        // last-resort static-ish fallback (won't match Google; only offline)
        return {
          GBP: 1, USD: 1.27, EUR: 1.17, CAD: 1.79, AUD: 1.96, NZD: 2.14,
          CHF: 1.10, JPY: 191, SGD: 1.71, HKD: 9.9, SEK: 13.0, NOK: 13.6,
          DKK: 8.72, PLN: 5.0, ZAR: 23.5, INR: 106, AED: 4.66, MXN: 24.5
        };
      });
  }

  /* Gap-fill a missing code from the same jsDelivr map (cached, merged). */
  var FX_CDN_URL = 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/gbp.min.json';
  var cdnRatesPromise = null;
  function fillMissingRates(rates, code) {
    if (!code || code === 'GBP' || (rates && rates[code] != null)) return Promise.resolve(rates);
    if (!cdnRatesPromise) {
      cdnRatesPromise = fetch(FX_CDN_URL, { credentials: 'omit', mode: 'cors' })
        .then(function (r) {
          if (!r.ok) throw new Error('fxcdn ' + r.status);
          return r.json();
        })
        .then(function (json) {
          var out = null;
          if (json && json.gbp) {
            out = {};
            Object.keys(json.gbp).forEach(function (k) { out[k.toUpperCase()] = Number(json.gbp[k]); });
          }
          return out;
        })
        .catch(function () { return null; });
    }
    return cdnRatesPromise.then(function (cdn) {
      if (cdn && cdn[code] != null) {
        rates = rates || { GBP: 1 };
        rates[code] = cdn[code];
        saveRates(rates);
      }
      return rates;
    });
  }

  function initPicker() {
    var picker = document.querySelector('[data-currency-picker]');
    if (!picker || picker.dataset.bound) return;
    picker.dataset.bound = '1';

    var trigger = picker.querySelector('.currency-trigger');
    var list = picker.querySelector('.currency-options');
    var scrim = picker.querySelector('[data-currency-scrim]');
    var options = Array.prototype.slice.call(picker.querySelectorAll('.currency-options li[data-currency]'));
    var nativeSelect = picker.querySelector('[data-currency-native]');
    var triggerFlag = trigger && trigger.querySelector('[data-flag]');
    var triggerLabel = trigger && (trigger.querySelector('[data-currency-label]') || trigger.querySelector('.currency-code'));

    if (!trigger || !list || !options.length) return;

    var ratesPromise = fetchRates();

    function isMobileSheet() {
      /* Real phones only: menu-button breakpoint AND no hover - a squeezed
         desktop window keeps the normal dropdown (Harry 2026-09-23). */
      return window.matchMedia('(max-width: 900px) and (hover: none)').matches;
    }
    function closeList() {
      if (picker.classList.contains('sheet-open')) {
        /* Keep sheet-open until the slide-down ends. Removing it early
           restores the mobile translateX on .currency-picker, and a
           transformed ancestor re-anchors the sheet's position:fixed to
           the flag for a frame = the dropdown blip. */
        if (picker._closeTimer) clearTimeout(picker._closeTimer);
        list.classList.remove('is-dragging');
        list.style.transform = '';
        list.classList.add('is-closing');
        trigger.setAttribute('aria-expanded', 'false');
        picker._closeTimer = setTimeout(function () {
          picker._closeTimer = null;
          picker.classList.remove('sheet-open');
          picker.classList.remove('open');
          list.classList.remove('is-closing');
          list.hidden = true;
        }, 260);
        return;
      }
      if (picker._closeTimer) {
        clearTimeout(picker._closeTimer);
        picker._closeTimer = null;
      }
      list.hidden = true;
      picker.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
      list.classList.remove('is-dragging');
      list.classList.remove('is-closing');
      list.style.transform = '';
    }
    function openList() {
      if (picker._closeTimer) {
        clearTimeout(picker._closeTimer);
        picker._closeTimer = null;
      }
      list.classList.remove('is-closing');
      list.hidden = false;
      picker.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      if (isMobileSheet()) picker.classList.add('sheet-open');
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      picker.classList.contains('open') ? closeList() : openList();
    });
    if (scrim) {
      scrim.addEventListener('click', function () {
        closeList();
      });
    }

    /* Swipe / flick down to close the mobile sheet. Drag tracks the finger;
       release past 80px or with downward velocity closes, else snaps back. */
    (function () {
      var startY = 0;
      var lastY = 0;
      var startT = 0;
      var dragging = false;
      list.addEventListener(
        'touchstart',
        function (e) {
          if (!isMobileSheet() || !picker.classList.contains('sheet-open')) return;
          startY = e.touches[0].clientY;
          lastY = startY;
          startT = Date.now();
          dragging = list.scrollTop <= 0;
        },
        { passive: true }
      );
      list.addEventListener(
        'touchmove',
        function (e) {
          if (!dragging || !picker.classList.contains('sheet-open')) return;
          lastY = e.touches[0].clientY;
          var dy = lastY - startY;
          if (dy > 0) {
            e.preventDefault();
            list.classList.add('is-dragging');
            list.style.transform = 'translateY(' + dy + 'px)';
          }
        },
        { passive: false }
      );
      list.addEventListener('touchend', function () {
        if (!dragging || !picker.classList.contains('sheet-open')) return;
        var dy = lastY - startY;
        var v = dy / Math.max(1, Date.now() - startT);
        dragging = false;
        if (dy > 80 || v > 0.5) {
          closeList();
        } else {
          list.classList.remove('is-dragging');
          list.style.transform = '';
        }
      });
    })();
    document.addEventListener('click', function (e) {
      if (!picker.contains(e.target)) closeList();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeList();
    });

    function selectCurrency(li, rates) {
      var code = (li.getAttribute('data-currency') || 'GBP').toUpperCase();
      var symbol = li.getAttribute('data-symbol') || '£';
      if (code === 'GBP') symbol = '£';
      var flagSrc = li.getAttribute('data-flag-src') || '';
      var rate = 1;
      if (code === 'GBP') rate = 1;
      else if (rates && rates[code] != null) rate = Number(rates[code]);
      else rate = parseFloat(li.getAttribute('data-rate')) || 1;

      window.APH.currency = { code: code, symbol: symbol, rate: rate };

      try {
        localStorage.setItem(STORAGE_KEY, code);
      } catch (e) {}

      if (triggerFlag && flagSrc) triggerFlag.src = flagSrc;
      if (triggerLabel) triggerLabel.textContent = code;
      if (nativeSelect) nativeSelect.value = code;
      options.forEach(function (o) {
        var on = o === li;
        o.classList.toggle('active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      applyCurrencyToDom();
      closeList();
    }

    options.forEach(function (li) {
      li.addEventListener('click', function () {
        var code = (li.getAttribute('data-currency') || 'GBP').toUpperCase();
        ratesPromise.then(function (rates) {
          fillMissingRates(rates, code).then(function (full) {
            selectCurrency(li, full);
          });
        });
      });
    });
    if (nativeSelect) {
      nativeSelect.addEventListener('change', function () {
        var match = options.filter(function (o) {
          return o.getAttribute('data-currency') === nativeSelect.value;
        })[0];
        if (match) {
          ratesPromise.then(function (rates) {
            fillMissingRates(rates, match.getAttribute('data-currency')).then(function (full) {
              selectCurrency(match, full);
            });
          });
        }
      });
    }

    // Restore last choice + fetch live rates
    ratesPromise.then(function (rates) {
      var saved = null;
      try {
        saved = localStorage.getItem(STORAGE_KEY);
      } catch (e) {}
      var match =
        options.filter(function (o) {
          return o.getAttribute('data-currency') === saved;
        })[0] || options[0];
      fillMissingRates(rates, (match.getAttribute('data-currency') || 'GBP').toUpperCase()).then(function (full) {
        selectCurrency(match, full);
      });
    });

    // Re-apply when cart drawer re-renders.
    // Harry 2026-08-17 ("can't have two currencies in the cart"): this
    // listened for a 'cart:updated' DOM CustomEvent that nothing in the
    // theme ever dispatches - cart-drawer.js/cart.js/etc all signal cart
    // changes via Shopify's real pub/sub system (PUB_SUB_EVENTS.cartUpdate,
    // see cart-drawer.js/cart.js/product-form.js). So this listener never
    // fired: after the first page load, newly-added/re-rendered cart line
    // items kept their freshly server-rendered (always-GBP) price text
    // while whichever lines were on the page at initial load stayed
    // converted to whatever currency was picked at that point - a mix.
    document.addEventListener('cart:updated', function () {
      setTimeout(applyCurrencyToDom, 50);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(applyCurrencyToDom, 50);
      });
    }
    if (window.Shopify && Shopify.theme) {
      document.addEventListener('shopify:section:load', function () {
        setTimeout(applyCurrencyToDom, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPicker);
  } else {
    initPicker();
  }
})();
